// ResultModal.tsx

import React from 'react';
import { Modal, Result, Button, Space, Divider } from 'antd';
import type { ResultStatusType } from 'antd/es/result';
import { DiffFilled } from '@ant-design/icons';

interface ResultModalProps {
    open: boolean;
    onClose: () => void;
    status?: ResultStatusType;
    title: string;
    subTitle?: string;
    buttonText?: string;
}

const ResultModal: React.FC<ResultModalProps> = ({
    open,
    onClose,
    status = 'info',
    title,
    subTitle,
    buttonText = 'Close',
}) => {
    return (
        <Modal
            open={open}
            footer={null}
            onCancel={onClose}
            centered
            width={500}
            destroyOnClose
        >             
            <Result
                status={status}
                title={title}
                subTitle={subTitle}
                extra={                
                    <Button type="dashed" onClick={onClose}>
                        {buttonText}
                    </Button>
                }
            />
        </Modal>
    );
};

export default ResultModal;